import React from 'react';
import { CircleDotIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { feelings, searchHabits } from '../../data/content';
export function Problem() {
  return <section className="bg-cream px-5 py-16 sm:py-24" data-id="element-271" data-mp="2rmkdaj3wvelq">
      <div className="mx-auto max-w-3xl" data-id="element-272" data-mp="2mptuvp4mw6x5">
        <SectionHeading eyebrow="What problem does the 7D Protocol™ solve?" title={<>
              When you feel you need to do <em className="text-brand-700" data-id="element-274" data-mp="2cqmknat74se9">something</em>, but don’t know what
            </>} subtitle="There are times when people feel they are going through a period of:" data-id="element-273" data-mp="2mp218julkj9i" />

        <ul className="mt-8 grid gap-2.5 sm:grid-cols-2" data-id="element-275" data-mp="23r7wii0i4twx">
          {feelings.map(f => <li key={f} className="flex items-start gap-3 rounded-xl bg-white px-4 py-3.5 text-[16px] text-ink ring-1 ring-brand-100" data-id="element-276" data-mp="6ypk5mmazoy6">
              <CircleDotIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-600" aria-hidden="true" data-id="element-277" data-mp="1zmd5wmrj8nk" />
              <span className="first-letter:uppercase" data-id="element-278" data-mp="149ileq9vyama">{f}</span>
            </li>)}
        </ul>

        <p className="mt-12 text-center text-[17px] font-semibold text-ink sm:text-lg" data-id="element-279" data-mp="19bg9pyx57vm3">And many people do the same thing:</p>
        <ol className="mx-auto mt-5 max-w-md border-l-2 border-dashed border-brand-200 pl-6" data-id="element-280" data-mp="vcq9iaf11fti">
          {searchHabits.map(h => <li key={h} className="relative py-2 text-[17px] text-ink-soft" data-id="element-281" data-mp="1nyszy0xwapit">
              <span className="absolute -left-[31px] top-1/2 h-3 w-3 -translate-y-1/2 rounded-full bg-brand-300" aria-hidden="true" data-id="element-282" data-mp="1s0ek87cre631" />
              {h}
            </li>)}
        </ol>

        <div className="mt-10 rounded-3xl bg-brand-800 px-6 py-10 text-center" data-id="element-283" data-mp="1j8ck6a6lqrta">
          <p className="text-sm font-semibold uppercase tracking-wider text-brand-200" data-id="element-284" data-mp="1j68a1ai40wkk">But then the same question appears</p>
          <p className="mt-3 font-display text-[28px] font-bold italic leading-tight text-white sm:text-4xl" data-id="element-285" data-mp="2bodkgo9p5uu7">
            “So what do I actually do now?”
          </p>
        </div>

        <div className="mt-10 space-y-4 text-center text-[17px] leading-relaxed text-ink-soft sm:text-lg" data-id="element-286" data-mp="2li9kohr91rvw">
          <p data-id="element-287" data-mp="2bmg14ef44y4m">That is exactly the problem I want to help you solve.</p>
          <p data-id="element-288" data-mp="2bklix7v87k48">You don’t necessarily need to start by collecting more information.</p>
          <p className="font-display text-2xl font-bold text-ink sm:text-3xl" data-id="element-289" data-mp="26mtoo773zlwv">You need a practical path.</p>
        </div>

        <CtaButton label="Yes, I want to know what to do" className="mt-10" data-id="element-290" data-mp="22nuoezwbodbr" />
      </div>
    </section>;
}